import * as React from 'react';
import { Select } from 'antd';

import InputControlProps from '../InputControlProps';

export interface MultiSelectDropdownState {}

export class MultiSelectDropdown extends React.Component<
  InputControlProps,
  MultiSelectDropdownState
> {
  renderOptions = () => {
    let availableValues = this.props.availableValues;

    let options = [];
    for (let key in availableValues) {
      let value = availableValues[key];
      options.push(
        <Select.Option key={key} value={key}>
          {value}
        </Select.Option>,
      );
    }
    return options;
  };

  onValueChanged = (value: string[]) => {
    this.props.onChange('[' + value.join(',') + ']');
  };

  parsePropsValue = () => {
    if (!this.props.value || this.props.value === '[]') {
      return [];
    }

    return this.props.value.startsWith('[') && this.props.value.endsWith(']')
      ? this.props.value.slice(1, -1).split(',')
      : [this.props.value.toString()];
  };

  render() {
    const { placeholder, disabled } = this.props;
    return (
      <Select
        style={{ width: '100%', minWidth: 200 }}
        mode="multiple"
        onChange={this.onValueChanged}
        placeholder={placeholder}
        disabled={disabled}
        value={this.parsePropsValue()}
        allowClear
        showSearch
      >
        {this.renderOptions()}
      </Select>
    );
  }
}

export default MultiSelectDropdown;
